import React from "react";
import Moment from "react-moment";
import { Phone, Globe, FileText, CheckCircle2, XCircle } from "lucide-react";
import "./ViewAgency.css";

const sectionTitleStyle = {
  fontSize: "12px",
  fontWeight: 700,
  color: "#94A3B8",
  textTransform: "uppercase",
  letterSpacing: "0.08em",
  borderBottom: "1px solid #EEF2F6",
  paddingBottom: "8px",
  marginBottom: "14px",
};

const labelStyle = {
  display: "block",
  fontSize: "12px",
  fontWeight: 700,
  color: "#2E6DA4",
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  marginBottom: "4px",
};

const valueStyle = {
  fontSize: "12px",
  fontWeight: 600,
  color: "#0F2D42",
  lineHeight: 1.5,
};

const fieldGridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
  gap: "18px",
};

const AgencyInfo = ({ agencyData }) => {
  if (!agencyData) {
    return (
      <div className="agv-page">
        <div className="agv-card agv-empty">No agency data available.</div>
      </div>
    );
  }

  const isActive = !!agencyData.status;

  return (
    <div className="agv-page">
      <div className="agv-card agv-card-body" style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
        {/* ── Basic Information ── */}
        <div>
          <div style={sectionTitleStyle}>Basic Information</div>
          <div style={fieldGridStyle}>
            <div>
              <label style={labelStyle}>Agency Name</label>
              <div style={valueStyle}>{agencyData.name || "NA"}</div>
            </div>
            <div>
              <label style={labelStyle}>Agency Type</label>
              <div style={valueStyle}>{agencyData.agency_type || "NA"}</div>
            </div>
            <div>
              <label style={labelStyle}>Created On</label>
              <div style={valueStyle}>
                {agencyData.created_on ? (
                  <Moment format="DD-MM-YYYY, hh:mm A">{agencyData.created_on}</Moment>
                ) : (
                  "NA"
                )}
              </div>
            </div>
          </div>
        </div>

        {/* ── Contact Information ── */}
        <div>
          <div style={sectionTitleStyle}>Contact Information</div>
          <div style={fieldGridStyle}>
            <div>
              <label style={labelStyle}>
                <Phone size={11} style={{ marginRight: "4px", verticalAlign: "-1px" }} />
                Phone Number
              </label>
              <div style={valueStyle}>{agencyData.phone || "NA"}</div>
            </div>
            <div>
              <label style={labelStyle}>
                <Globe size={11} style={{ marginRight: "4px", verticalAlign: "-1px" }} />
                Website
              </label>
              <div style={valueStyle}>{agencyData.website || "NA"}</div>
            </div>
            <div>
              <label style={labelStyle}>Status</label>
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "5px",
                  fontSize: "10.5px",
                  fontWeight: 700,
                  padding: "3px 10px",
                  borderRadius: "999px",
                  background: isActive ? "#E8F5E9" : "#F1F5F9",
                  color: isActive ? "#2E7D32" : "#64748B",
                  border: `1px solid ${isActive ? "#A5D6A7" : "#E2E8F0"}`,
                }}
              >
                {isActive ? <CheckCircle2 size={12} /> : <XCircle size={12} />}
                {isActive ? "Active" : "Inactive"}
              </div>
            </div>
          </div>
        </div>

        {/* ── Description ── */}
        <div>
          <div style={sectionTitleStyle}>
            <FileText size={11} style={{ marginRight: "4px", verticalAlign: "-1px" }} />
            Description
          </div>
          <div
            style={{
              ...valueStyle,
              fontWeight: 500,
              background: "#EBF4FA",
              border: "1px solid #E2E8F0",
              borderRadius: "10px",
              padding: "12px 14px",
            }}
          >
            {agencyData.description || "NA"}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgencyInfo;
